export const theme = {
  colors: {
    grey: '#d4d5d9',
    nearBlack: '#102e38',
    nearWhite: '#f8f0f2',
  },
  fontStack: '"Playfair Display", serif',
  radii: [0, 2, 4, 16, 9999, '100%'],
};
